
import { ChevronDown, ChevronRight } from "lucide-react";
import { getDatasetTabs } from "./dataset-tabs";

export default function Selector(props: any) {
  return (
    <div className="h-[94vh] overflow-y-auto bg-gray-50 border-r border-gray-200 shadow-sm flex flex-col">
      {Object.keys(props.chartInfo || {})
        .map((datasetId: string, datasetIndex: number) => {
          const isOpen = props.openDatasetList.includes(datasetId);
          const tabs = getDatasetTabs(datasetId, props.chartInfo);
          return (
            <div key={datasetIndex} className="border-b border-gray-100">
              <div
                className={`
                  flex items-center justify-between px-4 py-3 cursor-pointer transition-colors duration-200
                  ${isOpen ? "bg-white text-gray-900 font-semibold" : "text-gray-700 hover:bg-white hover:text-gray-900"}
                `}
                onClick={(e: any) => {
                  if (isOpen) {
                    props.setOpenDatasetList(props.openDatasetList.filter((item: string) => item !== datasetId));
                  } else {
                    props.setOpenDatasetList([...props.openDatasetList, datasetId]);
                  }
                }}
              >
                <div className="flex items-center gap-2 overflow-hidden">
                  <span className="truncate text-sm">{datasetId}</span>
                </div>
                {isOpen ? <ChevronDown size={16} className="text-gray-400 shrink-0" /> : <ChevronRight size={16} className="text-gray-400 shrink-0" />}
              </div>

              {isOpen && (
                <div className="bg-white pb-2">
                  {props.allDivisionRead ? (
                    <>
                      {props.chartInfo[datasetId]?.divisionItems ? (
                        <div className="px-4 py-2">
                          <select
                            onChange={(e: any) => {
                              console.log('onChange datasetId: ', datasetId);
                              console.log('onChange e.target.value: ', e.target.value);
                              console.log('onChange props.selectedDivision: ', props.selectedDivision);
                              props.setSelectedDivision({
                                ...props.selectedDivision,
                                [datasetId]: e.target.value
                              });
                            }}
                            className="block w-full py-1.5 px-3 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                          >
                            {[{ division_id: "All", division_name: "All" }]
                              .concat(Object.values(props.chartInfo[datasetId]?.divisionItems) || [])
                              .map((division: any, index: number) => (
                                <option key={index} value={division?.division_id}>{division?.division_name}</option>
                              ))}
                          </select>
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  <div className="flex flex-col mt-1">
                    {tabs
                      .map((tab: string, tabIndex: number) => {
                        const isActive = props.datasetId === datasetId && props.selectedTab === tab;
                        return (
                          <div
                            key={tabIndex}
                            className={`
                              px-4 pl-8 py-2 text-sm cursor-pointer transition-colors duration-150 border-l-4
                              ${isActive
                                ? "border-blue-500 bg-blue-50 text-blue-700 font-medium"
                                : "border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                              }
                            `}
                            onClick={(e: any) => {
                              props.setState({ selectedTab: tab, datasetId: datasetId });
                              props.onSelect();
                            }}
                          >
                            <span className="break-words block leading-snug">{tab}</span>
                          </div>)
                      })}
                  </div>
                </div>
              )}
            </div>
          );
        })}
    </div>
  )
}
